import { OrganizationNames } from '../../assets/images/cuisines/content'

const modKitchenTermsOfUse = `
# MOD Kitchen – Terms and Conditions

**Effective Date:** March 15th, 2025 **Last Updated:** March 15th, 2025

## 1. Introduction

Welcome to **MOD Kitchen** ("we," "our," or "us"). By accessing and using **[www.modkitchen.ca]** (the "Website"), you agree to be bound by these **Terms and Conditions** ("Terms"). If you do not agree with any part of these Terms, please do not use our services.

## 2. Eligibility & User Responsibilities

* You must be **at least 18 years old** or have parental/guardian consent to use this Website.
* You agree to use this Website **only for lawful purposes** and in compliance with all applicable laws in **Canada**.
* You are responsible for ensuring that any **account information** you provide is accurate and up to date.

## 3. Ordering & Payment Policy

* All orders placed through MOD Kitchen are subject to availability. We reserve the right to **cancel or refuse orders** at our discretion.
* Prices listed on the Website **exclude applicable taxes** and are subject to change without notice.
* Payments must be made **at the time of ordering** via accepted payment methods. We use third-party payment processors to secure transactions.
* If there are issues with your order (e.g., incorrect items, missing products), please **contact us within 24 hours** of receiving your order.

## 4. Refund & Cancellation Policy

* Orders can only be canceled if the request is made **before preparation begins**.
* Refunds are granted on a **case-by-case basis** at MOD Kitchen's discretion.
* If your order arrives **incorrect, incomplete, or damaged**, please provide **proof (e.g., photos)** and reach out to our support team for resolution.

## 5. Privacy & Data Protection

* MOD Kitchen complies with **Canada's Personal Information Protection and Electronic Documents Act (PIPEDA)**.
* By using this Website, you agree to the **collection, storage, and processing of your personal information** in accordance with our **[Privacy Policy]**.
* We do not **sell, trade, or rent** your personal information to third parties without your consent.

## 6. Intellectual Property Rights

* All **content, logos, images, and text** on the Website are the property of MOD Kitchen or our licensors.
* You may **not copy, distribute, or reproduce** any material from this Website without our written consent.

## 7. Third-Party Links & Services

* Our Website may contain links to **third-party websites** (e.g., delivery platforms, payment processors). We are **not responsible** for their content, policies, or practices.
* If you choose to interact with third-party services, you do so at your **own risk**.

## 8. Limitation of Liability

* MOD Kitchen is **not liable** for any **indirect, incidental, or consequential damages** arising from: 
   * Use of or inability to use our Website.
   * Service delays, technical errors, or system failures.
   * Errors in product descriptions, pricing, or availability.
* Our liability, under any circumstances, **shall not exceed the amount paid for your order**.

## 9. Modifications & Updates

* MOD Kitchen reserves the right to **update or modify** these Terms at any time.
* Any changes will be effective immediately upon posting on the Website.
* It is your responsibility to review these Terms periodically.

## 10. Governing Law

These Terms are governed by the **laws of British Columbia, Canada**. Any disputes shall be subject to the exclusive jurisdiction of the courts in Vancouver, BC.

## 11. Contact Information

For any inquiries regarding these Terms, please contact us:

📧 **Email:** info@modkitchen.ca  
📞 **Phone:** (604) 238-1637  
📍 **Address:** Unit 15 & 16 Horseshoe Way, Richmond, BC
`

export const ORGANIZATION_TERMS_OF_USE_MAP = {
	[OrganizationNames.ModKitchen]: modKitchenTermsOfUse,
}
